// Pure helpers behind the `$.fn.changed` jQuery plugin in dom_ready.js.
//
// Extracted so the iteration strategy can be unit tested without a DOM (jsdom isn't available
// here) — `runDomChangedCallbacks` only needs something that quacks like a jQuery collection.

export const DEFAULT_PRIORITY = 100

// Ascending priority; Array#sort is stable, so same-priority callbacks keep registration order.
export function sortByPriority(callbacks) {
  return [...callbacks].sort(
    (a, b) => (a[2] || DEFAULT_PRIORITY) - (b[2] || DEFAULT_PRIORITY)
  )
}

// Runs every registered onDomChanged callback against `collection`.
//
// Callback-major, NOT node-major: each selector is matched once against the whole collection
// instead of once per node. Refreshing a 12-card grid used to mean 12 × ~69 = ~830 Sizzle passes,
// each of which makes Sizzle set and remove a temporary `id` attribute on the context element —
// real DOM mutations that invalidate style. Now it is ~69 passes total.
//
// It also means the registered `priority` finally orders callbacks across the whole collection
// rather than only within a single node.
//
// `wrap` is jQuery itself: callbacks are invoked with `this` bound to a jQuery object wrapping a
// single element, which is the contract every existing onDomChanged callback relies on.
export function runDomChangedCallbacks({ collection, callbacks, wrap }) {
  for (const [selector, callback] of callbacks) {
    if (!callback) continue

    const invoke = function () {
      callback.call(wrap(this))
    }

    collection.filter(selector).each(invoke)
    collection.find(selector).each(invoke)
  }
}
